import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const NODE_TYPES = ['locations', 'trades', 'wbs', 'activities', 'materials'];
const TTL = 60 * 1000;
const cache = {};

// Loads and caches all construction nodes for a project (active only).
export async function loadProjectNodes(projectId, force = false) {
  if (!projectId) return { byId: {}, locations: [], trades: [], wbs: [], activities: [], materials: [] };
  if (!force && cache[projectId] && Date.now() - cache[projectId].ts < TTL) return cache[projectId];
  const results = await Promise.all(
    NODE_TYPES.map((t) => axios.get(`${API}/projects/${projectId}/construction/${t}`).then((r) => r.data || []).catch(() => []))
  );
  const byId = {};
  NODE_TYPES.forEach((t, i) => (results[i] || []).forEach((n) => { byId[n.id] = { ...n, _type: t }; }));
  const data = {
    ts: Date.now(), byId,
    locations: results[0] || [], trades: results[1] || [], wbs: results[2] || [],
    activities: results[3] || [], materials: results[4] || [],
  };
  cache[projectId] = data;
  return data;
}

export function invalidateProjectNodes(projectId) {
  if (projectId) delete cache[projectId];
  else Object.keys(cache).forEach((k) => delete cache[k]);
}

// Fields a construction context can carry, in display order.
export const CONTEXT_FIELD_ORDER = ['siteId', 'buildingId', 'floorId', 'zoneId', 'spaceId', 'tradeId', 'wbsId', 'activityId', 'materialId'];

// True if a record's context matches every set field in the filter.
export function matchesContextFilter(context, filter) {
  if (!filter || Object.keys(filter).length === 0) return true;
  const ctx = context || {};
  return Object.entries(filter).every(([field, val]) => !val || ctx[field] === val);
}
